import { render, staticRenderFns } from "./ValveAttr.vue?vue&type=template&id=0b86c442&scoped=true&"
import script from "./ValveAttr.vue?vue&type=script&lang=js&"
export * from "./ValveAttr.vue?vue&type=script&lang=js&"
import style0 from "./ValveAttr.vue?vue&type=style&index=0&id=0b86c442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86c442",
  null
  
)

export default component.exports